import { Box, Typography, Avatar, Button } from "@mui/material";

import { DateTimeLabel } from "../../components/DateTimeLabel";
import { formatCurrencyToShow } from "../../helpers/currency";
import { Withdrawal } from "../../interfaces/withdrawal";

interface Props {
    data: Withdrawal;
    onClick?: () => void;
}

export function WithdrawalItem({ data, onClick }: Props) {
    return (
        <Box display="flex" alignItems="center" py={2}>
            <Avatar sx={{ bgcolor: "grey.200", color: "grey.700" }}>
                {data.recipient_name.charAt(0)}
            </Avatar>

            <Box flex={1} ml={2}>
                <Typography fontWeight={500}>{data.recipient_name}</Typography>
                <Typography variant="body2" color="text.secondary">
                    Solicitado em <DateTimeLabel value={data?.created_at} />
                </Typography>
            </Box>

            <Box textAlign="right" mr={2}>
                <Typography fontWeight={600}>
                    R${formatCurrencyToShow(data.amount)}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                    Saldo disponível
                </Typography>
            </Box>

            <Button variant="contained" onClick={onClick}>
                Analisar
            </Button>
        </Box>
    );
}
